var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('v-card',{staticClass:"overflow-hidden d-flex wrap mx-auto"},[_c('navigation-list',{attrs:{"navigationList":_vm.navigationList}}),_c('v-main',{staticClass:"wrap_content"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }